import { Mapper } from "../../../../base/utils/mapper";
import { TestExternalResponseModel } from "../../../../domain/models/consult/test-external.response.model";
import { TestExternalResponseEntity } from "../entities/test-external.response.entity";



export class TestExternalImplementationRepositoryMapper extends Mapper<TestExternalResponseEntity, TestExternalResponseModel> {
    mapFrom(param: TestExternalResponseEntity): TestExternalResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TestExternalResponseModel): TestExternalResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}